<template>
  <form-button
    icon="plus"
    :href="href"
  >
    Novo alerta
  </form-button>
</template>

<script>
  import FormButton from '@cordel/components/Form/Button.vue';

  export default {
    name: 'SystemAlertsListNew',
    components: {
      FormButton,
    },
    computed: {
      href() {
        return {
          name: 'settings-system-alerts-new',
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';
</style>
